<template>
  <b-modal
    v-if="hotAlert"
    id="modal-hotalert"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    :title="$t('HotAlert Detail')"
    size="xl"
    ok-only
    :ok-title="$t('Close')"
  >
    <div class="p-2">
      <div class="text-center">
        <b-avatar
          size="60"
          :variant="variant"
        >
          <feather-icon
            size="38"
            :icon="icon"
          />
        </b-avatar>
        <h3 class="mt-1 mb-2">{{ hotAlert.hotalertreason }}
          <br><small>{{ formatDate(hotAlert.createdate) }}</small>
        </h3>

      </div>

      <b-row>
        <b-col md="4">
          <h3 class="mt-2">
            {{ $t('Survey Detail') }}
          </h3>
          <div style="overflow:auto;max-height:500px;">

            <survey-viewer
              :projectid="hotAlert.projectid"
              :orjref="hotAlert.orjref"
            />

          </div>

        </b-col>
        <b-col md="4">
          <h3 class="mt-2">
            {{ $t('Action Planning') }}
          </h3>

          <b-tabs
            v-model="tabIndex"
          >
            <b-tab :title="$t('Assign Action')">
              <form-hot-alert
                v-if="hotAlertAction"
                ref="hotAlertForm"
                v-model="hotAlertAction"
                :projectid="hotAlert.projectid"
                :orjref="hotAlert.orjref"
                class="mt-1"
                @submit="getHotAlertLog"
              />
            </b-tab>
            <b-tab
              :title="$t('Contact Status')"
              :disabled="hotAlertAction&&!hotAlertAction.assignedTo"
            >
              <form-hot-alert-contact-status
                v-if="hotAlertAction&&hotAlertAction.assignedTo"
                ref="hotAlertContactStatusForm"
                v-model="hotAlert"
                class="mt-1"
                @submit="getHotAlertLog"
                @refreshHotAlert="refreshHotAlert"
              />
            </b-tab>
            <b-tab
              :title="$t('Close Action')"
              :disabled="hotAlertAction&&(!hotAlertAction.assignedTo||hotAlert.contactstatus!='Müşteri ile görüşüldü')"
            >
              <form-hot-alert-close
                v-if="hotAlertAction&&hotAlertAction.assignedTo"
                ref="hotAlertCloseForm"
                v-model="hotAlertAction"
                class="mt-1"
                :hot-alert="hotAlert"
                @submit="getHotAlertLog"
                @refreshHotAlert="refreshHotAlert"
              />
            </b-tab>

          </b-tabs>

        </b-col>
        <b-col md="4">
          <h3 class="mt-2">
            {{ $t('Timeline') }}
          </h3>
          <app-timeline>
            <app-timeline-item
              v-for="(item,index) in timeline"
              :key="index"
              class="mt-1"
              :title="item.title"
              :subtitle="item.subtitle"
              :description="item.description"
              :time="item.time"
              :variant="item.variant"
            />
          </app-timeline>
        </b-col>
      </b-row>
    </div>

  </b-modal>
</template>

<script>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import useJwt from '@/auth/jwt/useJwt'
import {
  BModal, VBModal, BAvatar, BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import FormHotAlert from './forms/FormHotAlert.vue'
import FormHotAlertClose from './forms/FormHotAlertClose.vue'
import FormHotAlertContactStatus from './forms/FormHotAlertContactStatus.vue'
import SurveyViewer from './SurveyViewer.vue'

dayjs.extend(relativeTime)

export default {
  components: {
    BModal,
    BAvatar,
    BRow,
    BCol,
    BTabs,
    BTab,
    AppTimeline,
    AppTimelineItem,
    FormHotAlert,
    FormHotAlertClose,
    FormHotAlertContactStatus,
    SurveyViewer,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      tabIndex: 0,
      timeline: [],
      hotAlert: null,
      surveyData: null,
      hotAlertAction: null,
      blankAssignForm: {
        assignedTo: null,
        assignedDate: null,
        assignedBy: null,
        actionPlanned: null,
        actionTaken: null,
        actionTakenDate: null,
      },
    }
  },
  computed: {
    icon() {
      if (this.hotAlert) {
        return this.hotAlert.status.replace('Assigned', 'UserCheckIcon').replace('Unassigned', 'InfoIcon').replace('Closed', 'CheckCircleIcon').replace('Overdue', 'AlertTriangleIcon')
      }
      return null
    },
    variant() {
      if (this.hotAlert) {
        return this.hotAlert.status.replace('Assigned', 'info').replace('Unassigned', 'warning').replace('Closed', 'success').replace('Overdue', 'danger')
      }
      return null
    },
  },
  watch: {
    hotAlert() {
      this.getHotAlertLog()
    },
  },
  created() {
    this.getHotAlertLog()
  },
  mounted() {
    this.$root.$on('view_hotalert', hotAlert => {
      this.hotAlert = hotAlert
      if (this.hotAlert.categories) {
        this.hotAlert.categories = this.hotAlert.categories.split('|')
      } else {
        this.hotAlert.categories = []
      }
      this.$nextTick(() => {
        this.$bvModal.show('modal-hotalert')
      })
    })
  },
  beforeDestroy() {
    this.$root.$off('view_hotalert')
  },
  methods: {
    formatDate(date) {
      return dayjs(date).fromNow()
    },
    refreshHotAlert() {
      if (this.hotAlert) {
        useJwt.axiosIns.get(`hotAlert/${this.hotAlert.id}`).then(response => {
          this.hotAlert = response.data
        })
      }
    },
    getHotAlertLog() {
      if (this.hotAlert) {
        useJwt.axiosIns.get(`hotAlert/assigments/${this.hotAlert.projectid}/${this.hotAlert.orjref}`).then(response => {
          this.timeline = []
          console.log('getHotAlertLog', response.data)
          if (response.data.length) {
            const list = response.data
            if (list.length) {
              // get first item of list
              this.hotAlertAction = JSON.parse(JSON.stringify(list[0]))
            }
          } else {
            this.hotAlertAction = JSON.parse(JSON.stringify(this.blankAssignForm))
            this.hotAlertAction.projectId = this.hotAlert.projectid
            this.hotAlertAction.orjRef = this.hotAlert.orjref
            this.hotAlertAction.actionPlanned = null
            this.hotAlertAction.assignedDate = this.hotAlert.createdate
          }

          response.data.forEach(x => {
            if (x.actionTaken && x.actionTakenDate) {
              this.timeline.push({
                title: dayjs(x.actionTakenDate).format('DD.MM.YYYY HH:mm'),
                subtitle: `${this.$t(x.assignedBy)}${x.assignedTo ? ` --> ${x.assignedTo}` : ''}`,
                description: `${this.$t('Action')}: ${x.actionTaken}`,
                time: dayjs(x.actionTakenDate).fromNow(),
                variant: 'success',
              })
            } else {
              this.timeline.push({
                title: dayjs(x.assignedDate).format('DD.MM.YYYY HH:mm'),
                subtitle: `${this.$t(x.assignedBy)}${x.assignedTo ? ` --> ${x.assignedTo}` : ''}`,
                description: `${this.$t('Action')}: ${x.actionPlanned}`,
                time: dayjs(x.assignedDate).fromNow(),
                variant: x.actionPlannedDate && x.actionPlannedDate < new Date() ? 'danger' : 'info',
              })
            }
          })
        })
      }
      this.$emit('refreshHotalertList')
    },
  },
}
</script>
